import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column gr-md-8 gr-sm-7 gr-6 registration-form-content",
        },
        [
          _vm.isDoctor && _vm.subject
            ? _c(_setup.DoctorCard, {
                class: { "elevation-1 pa-4": !_setup.isMobile },
                attrs: { doctor: _vm.subject },
              })
            : _vm._e(),
          _vm._v(" "),
          !_setup.isFinished
            ? [
                !_setup.isMobile
                  ? _c("div", { staticClass: "text-h5 text-center" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t(
                              _vm.isLpu
                                ? "Для регистрации клиники заполните форму"
                                : "Для регистрации врача заполните форму",
                              _setup.options
                            )
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex flex-column gr-4" },
                  [
                    _c(_setup.UserForm, {
                      ref: "userFormRef",
                      staticClass: "mb-4",
                      attrs: {
                        "is-doctor": _vm.isDoctor,
                        "is-lpu": _vm.isLpu,
                        "email-error-message": _setup.emailErrorMessage,
                        "is-alert-foreign-email-visible":
                          _setup.isAlertForeignEmailVisible,
                      },
                      on: { "reset-email-error": _setup.resetEmailError },
                    }),
                    _vm._v(" "),
                    _setup.isVisibleAgreementYdoc ||
                    _vm.isLpu ||
                    (_vm.isDoctor && _vm.phoneConfirmationOnDoctorRegister)
                      ? _c(
                          "div",
                          { staticClass: "d-flex flex-column gr-4" },
                          [
                            _setup.isVisibleAgreementYdoc
                              ? _c(_setup.RegistrationFormAgreement, {
                                  class: _setup.isButtonSendVisible
                                    ? "order-1"
                                    : "order-0",
                                  attrs: {
                                    "is-lpu": _vm.isLpu,
                                    "is-doctor": _vm.isDoctor,
                                    "registration-agreement-link":
                                      _setup.registrationAgreementLink,
                                  },
                                  model: {
                                    value: _setup.isAgreeWithAgreement,
                                    callback: function ($$v) {
                                      _setup.isAgreeWithAgreement = $$v
                                    },
                                    expression: "isAgreeWithAgreement",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isLpu ||
                            (_vm.isDoctor &&
                              _vm.phoneConfirmationOnDoctorRegister)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "registration-form-content__user-authorization mb-4",
                                    class: {
                                      "registration-form-content__user-authorization--with-btn":
                                        !_setup.isButtonSendVisible,
                                    },
                                  },
                                  [
                                    _setup.UserAuthorization
                                      ? _c(_setup.UserAuthorization, {
                                          key: _setup.userAuthorizationKey,
                                          tag: "component",
                                          attrs: {
                                            persistent: "",
                                            "is-no-registration": "",
                                            "is-country-authorization": true,
                                            "hook-before-submit-form":
                                              _setup.beforeCodeRequest,
                                          },
                                          on: {
                                            "authorization:confirmed":
                                              function ($event) {
                                                _setup.userPhone = $event
                                              },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column gr-4" },
                      [
                        _setup.isButtonSendVisible
                          ? _c(
                              VBtn,
                              {
                                attrs: {
                                  block: "",
                                  elevation: "0",
                                  color: "primary",
                                  disabled: !_setup.isAgreeWithAgreement,
                                },
                                on: { click: _setup.sendForm },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _setup.t("Отправить", _setup.options)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.isVisibleAgreementYdoc
                          ? _c(_setup.PolicyAndTermsYdoc, {
                              attrs: {
                                "is-button-send-visible":
                                  _setup.isButtonSendVisible,
                              },
                            })
                          : _c(_setup.PolicyAndTerms, {
                              model: {
                                value: _setup.isAgreeWithAgreement,
                                callback: function ($$v) {
                                  _setup.isAgreeWithAgreement = $$v
                                },
                                expression: "isAgreeWithAgreement",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _c(_setup.ScreenConfirmEmail, {
                attrs: {
                  "user-email": _setup.userEmail,
                  "date-of-sending-email": _vm.dateOfSendingEmail,
                },
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c(_setup.ErrorDialog, {
        attrs: { error: _setup.alertError },
        model: {
          value: _setup.isAlertErrorVisible,
          callback: function ($$v) {
            _setup.isAlertErrorVisible = $$v
          },
          expression: "isAlertErrorVisible",
        },
      }),
      _vm._v(" "),
      _c(
        _setup.CoreDialog,
        {
          attrs: {
            "data-qa": "registration-form-progress-modal",
            size: "sm",
            persistent: "",
          },
          model: {
            value: _setup.isProgressVisible,
            callback: function ($$v) {
              _setup.isProgressVisible = $$v
            },
            expression: "isProgressVisible",
          },
        },
        [
          _c(VProgressCircular, {
            staticClass: "mt-3 mb-6 mx-auto",
            attrs: {
              size: "40",
              width: "3",
              color: "primary",
              indeterminate: "",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-1 text-center mb-2" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Подождите", _setup.options)) +
                "...\n    "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }